import { jsx as _jsx } from "react/jsx-runtime";
import { Air } from "@air/next-icons";
import Link from "next/link";
import { Routes } from "~/constants/routes";
export const PasswordPageHeader = ()=>/*#__PURE__*/ _jsx("header", {
        className: "absolute left-0 top-0 z-[3] w-full border-t-2 border-teal-7 pl-6 pt-1 md:pl-8",
        children: /*#__PURE__*/ _jsx(Link, {
            href: Routes.root,
            passHref: true,
            children: /*#__PURE__*/ _jsx(Air, {
                className: "w-20 text-blue-9"
            })
        })
    });
PasswordPageHeader.displayName = "PasswordPageHeader";
